<div *ngIf="text && !!text.length" class="description">
	<h2>{{ header | hisUi }}</h2>	
		<i>
			<div *ngIf="!hisobject || !hisAttribute">
			<!-- show the shortened text -->
				<span class="wordBreak" *ngIf="!showFullText && isMaxTextLength()">{{getMaxTextLength(text)}}</span>
				<!-- show text in full length -->
				<span class="wordBreak" *ngIf="showFullText || !isMaxTextLength()">{{text}}</span>
			</div>
			
			<div *ngIf="hisobject && hisAttribute">
				<!-- show the shortened text -->		
				<ng-container  *ngIf="!showFullText && isMaxTextLength()"> 
				    <his-translated-text [hisobject]="hisobject" [hisAttribute]="hisAttribute" [maxLength]="maxLength"></his-translated-text>
				</ng-container>
				
				<!-- show text in full length -->
				<ng-container *ngIf="showFullText || !isMaxTextLength()">
					<his-translated-text [hisobject]="hisobject" [hisAttribute]="hisAttribute"></his-translated-text><br/>
				</ng-container>
	        </div>
			
			<!-- Only show buttons to open/close if text is longer than the preset maximum length -->
			<ng-container *ngIf="isMaxTextLength()">
				<button *ngIf="!showFullText" (click)="setShowFullText(true)" class="icon" hisImage="ARROW_DOWN_V" title="{{ expandToolTip | hisUi }}"></button>
				<button *ngIf="showFullText" (click)="setShowFullText(false)" class="icon" hisImage="ARROW_UP_V" title="{{ collapseToolTip | hisUi }}"></button>
			</ng-container>
		 </i>	
</div> 